module.exports = "<p>\n  logout works!\n</p>\n";


//////////////////
// WEBPACK FOOTER
// ./ClientApp/app/components/logout/logout.component.html
// module id = 180
// module chunks = 0